module.exports = __webpack_public_path__ + "static/img/birth_count.1b60641.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/scflow/birth_count.png
// module id = 205
// module chunks = 32